import React from 'react';
import { Link } from 'react-router-dom';

import {
  Mail,
  Wind,
  Lock,
  FlaskConical,
  Leaf,
  Award,
} from 'lucide-react';

import {
  FaInstagram,
  FaTwitter,
  FaYoutube,
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--forest)',
      color: 'var(--white)',
      padding: '72px 32px 36px',
    }}>
      <div style={{
        maxWidth: '1280px', margin: '0 auto',
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr 1fr',
          gap: '48px',
          marginBottom: '60px',
        }} className="footer-grid">

          {/* Brand */}
          <div>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '10px',
              marginBottom: '20px',
            }}>
              <div style={{
                width: '38px', height: '38px',
                background: 'rgba(255,255,255,0.1)',
                borderRadius: '8px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <Wind size={18} color="rgba(255,255,255,0.85)" />
              </div>
              <span style={{
                fontFamily: 'Syne', fontWeight: 700, fontSize: '1.1rem',
                letterSpacing: '-0.02em',
              }}>MIND BLOWN</span>
            </div>
            <p style={{
              fontSize: '0.87rem', color: 'rgba(255,255,255,0.5)',
              lineHeight: '1.8', maxWidth: '300px', marginBottom: '28px',
            }}>
              Curated hemp-derived THC products crafted for the discerning adult.
              Pure state of mind, every time.
            </p>
            
            <div style={{ display: 'flex', gap: '12px' }}>
              {[
                { Icon: FaInstagram, label: 'Instagram', href: 'https://instagram.com/mindblown' },
                { Icon: FaTwitter,   label: 'Twitter',   href: 'https://twitter.com/mindblown'   },
                { Icon: FaYoutube,   label: 'YouTube',   href: 'https://youtube.com/@mindblown'  },
              ].map(({ Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  style={{
                    width: '36px',
                    height: '36px',
                    background: 'rgba(255,255,255,0.08)',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'rgba(255,255,255,0.6)',
                    textDecoration: 'none',
                    transition: 'all 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'var(--gold)';
                    e.currentTarget.style.color = 'var(--white)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                    e.currentTarget.style.color = 'rgba(255,255,255,0.6)';
                  }}
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 style={{
              fontFamily: 'Syne', fontWeight: 700, fontSize: '0.75rem',
              letterSpacing: '0.1em', textTransform: 'uppercase',
              color: 'var(--gold)', marginBottom: '20px',
            }}>Shop</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {['THC Drinks', 'Gummies', 'Flower', 'Vapes', 'Bundles', 'Build a Box'].map(item => (
                <Link key={item} to="/shop" style={{
                  fontSize: '0.87rem', color: 'rgba(255,255,255,0.55)',
                  transition: 'color 0.2s', textDecoration: 'none',
                }}
                onMouseEnter={e => e.target.style.color = 'var(--white)'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}>
                  {item}
                </Link>
              ))}
            </div>
          </div>

          {/* Info */}
          <div>
            <h4 style={{
              fontFamily: 'Syne', fontWeight: 700, fontSize: '0.75rem',
              letterSpacing: '0.1em', textTransform: 'uppercase',
              color: 'var(--gold)', marginBottom: '20px',
            }}>Info</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {['About Us', 'Lab Results', 'Shipping Policy', 'Returns', 'FAQ', 'Contact'].map(item => (
                <Link key={item} to="/about" style={{
                  fontSize: '0.87rem', color: 'rgba(255,255,255,0.55)',
                  transition: 'color 0.2s', textDecoration: 'none',
                }}
                onMouseEnter={e => e.target.style.color = 'var(--white)'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}>
                  {item}
                </Link>
              ))}
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 style={{
              fontFamily: 'Syne', fontWeight: 700, fontSize: '0.75rem',
              letterSpacing: '0.1em', textTransform: 'uppercase',
              color: 'var(--gold)', marginBottom: '20px',
            }}>Stay Elevated</h4>
            <p style={{
              fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)',
              lineHeight: '1.7', marginBottom: '16px',
            }}>
              Exclusive drops and early access. No spam.
            </p>
            <div style={{
              display: 'flex', flexDirection: 'column', gap: '10px',
            }}>
              <input
                placeholder="your@email.com"
                style={{
                  padding: '12px 16px',
                  borderRadius: '8px',
                  border: '1.5px solid rgba(255,255,255,0.12)',
                  background: 'rgba(255,255,255,0.06)',
                  color: 'var(--white)', fontFamily: 'DM Sans',
                  fontSize: '0.85rem', outline: 'none',
                  transition: 'border 0.2s',
                }}
                onFocus={e => e.target.style.borderColor = 'var(--gold)'}
                onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.12)'}
              />
              <button style={{
                padding: '12px',
                borderRadius: '8px',
                background: 'var(--gold)',
                color: 'var(--white)',
                border: 'none', cursor: 'pointer',
                fontFamily: 'Syne', fontWeight: 700,
                fontSize: '0.78rem', letterSpacing: '0.06em',
                textTransform: 'uppercase',
                transition: 'all 0.2s',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--gold-light)'}
              onMouseLeave={e => e.currentTarget.style.background = 'var(--gold)'}>
                <Mail size={13} /> Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Trust badges */}
        <div style={{
          display: 'flex', flexWrap: 'wrap', gap: '24px',
          padding: '28px 0',
          borderTop: '1px solid rgba(255,255,255,0.08)',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          marginBottom: '28px',
          alignItems: 'center',
        }}>
          {[
            { Icon: Leaf,         label: '100% Organic Hemp'        },
            { Icon: Award,        label: 'CGMP Certified Facility'  },
            { Icon: FlaskConical, label: 'Third-Party Lab Tested'   },
            { Icon: Lock,         label: 'Secure Age Verified'      },
          ].map(({ Icon, label }) => (
            <span key={label} style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              fontSize: '0.78rem', color: 'rgba(255,255,255,0.45)',
              fontWeight: 500,
            }}>
              <Icon size={13} color="var(--gold)" />
              {label}
            </span>
          ))}
        </div>

        {/* Bottom */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: '12px',
        }}>
          <p style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.3)' }}>
            © 2026 Mind Blown · mindblownus.com · All rights reserved.
          </p>
          <p style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.25)', maxWidth: '480px', textAlign: 'right' }}>
            For use by adults 21+ only. These statements have not been evaluated by the FDA.
            Not intended to diagnose, treat, cure, or prevent any disease.
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 560px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;